<template>
  <v-card :flat="flat" height="100%">
    <v-card-title class="py-2 font-weight-black">
      {{ $t('delivery.payment.title') }}
    </v-card-title>
    <v-row no-gutters>

      <v-col cols="12" sm="12" :md="vertical ? 12 : 4">
        <show-field v-if="order && order.payment"
                    :value="$t('delivery.payment.method.'+order.payment.method)"
                    :label="$t('delivery.order.labels.paymentMethod')"
                    :icon="getIcon"
        />
      </v-col>

      <v-col cols="12" sm="12" :md="vertical ? 12 : 3">
        <show-field
            :value=" '$'+totalAmount"
            :label="$t('delivery.cart.total')"
            icon="payments"
        />

      </v-col>

      <v-col cols="12" sm="12" :md="vertical ? 12 : 3">
        <show-field
            v-if="order && order.payment"
            :value="order.payment.confirmed ? 'Si' : 'No'"
            :label="$t('delivery.payment.paid')"
            icon="price_check"
        />

      </v-col>

      <v-col cols="12" sm="12" :md="vertical ? 12 : 3">
        <show-field
            v-if="order.discountRate || order.discountAmount"
            :value="order.discountRate ? '-'+ order.discountRate + '%' : '-$'+order.discountAmount.toLocaleString('es-AR')"
            :label="$t('delivery.payment.discount')"
            icon="discount"
        />

      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-card outlined v-if="isPaymentDataRequired" class="mx-6 my-2">
          <payment-data
              :payment-method="order.payment.method"
          ></payment-data>
        </v-card>
      </v-col>

    </v-row>
    <v-btn
        v-if="order.payment.receiptFile"
        absolute icon top right
        :href="order.payment.receiptFile" target="_blank"
    >
      <v-icon>attachment</v-icon>
    </v-btn>
    <v-divider v-if="divider"></v-divider>
  </v-card>
</template>

<script>
import {ShowField} from '@dracul/common-frontend'
import PaymentData from "@/modules/payment/components/PaymentData/PaymentData.vue";

export default {
  name: "OrderPayment",
  components: {PaymentData, ShowField},
  props: {
    order: {type: Object, required: true},
    totalAmount: {type: Number, required: true},
    divider: {type: Boolean, default: false},
    flat: {type: Boolean, default: false},
    title: {type: String, default: 'delivery.mode.deliveryMode'},
    vertical: {type: Boolean, default: false},
  },
  created() {
    if (this.paymentMethods === null) {
      this.$store.dispatch('findPaymentMethods')
    }
  },
  computed: {
    paymentMethod() {
      return this.order.payment.method
    },
    paymentMethods() {
      return this.$store.getters.getPaymentMethods
    },
    isPaymentDataRequired() {
      if(!this.paymentMethods){
        return false
      }

      if (this.paymentMethod === this.paymentMethods.bankTransfer.identifier || this.paymentMethod === this.paymentMethods.mercadoPagoTransfer.identifier) {
        return true
      }
      return false
    },
    getIcon() {
      switch (this.order.payment.method) {
        case 'CASH':
          return 'monetization_on'
        case 'BANK_TRANSFER':
          return 'account_balance'
        case 'MP_TRANSFER':
          return 'account_balance'
        default:
          return 'monetization_on'
      }
    }
  }
}
</script>

<style scoped>

</style>
